export default {
  LOAD_CYCLE_CASE_OVERVIEW_PAGE_START: 'LoadCycleCaseOverviewPageStart',
  LOAD_CYCLE_CASE_OVERVIEW_PAGE_END: 'LoadCycleCaseOverviewPageEnd'
};